(function (Drupal, $,once) {
  Drupal.behaviors.aosFix = {
    attach: function (context) {
      "use strict";

        if (window.location.hash) {
          var hash = window.location.hash;
      
          if ($(hash).length) {
            console.log(hash)
              $('html, body').animate({
                  scrollTop: $(hash).offset().top  -  100
              }, 300, 'swing');
          }
      }

      AOS.init({
        startEvent: "DOMContentLoaded",
        offset: 100,
        duration: 350,
        easing: "ease-out-quad",
      });
      $(once("aosFix",document, context))
        .ajaxSuccess(function () {
          AOS.init({
            startEvent: "DOMContentLoaded",
            offset: 120,
            duration: 450,
            easing: "ease-out-quad",
          });
        });
    },
  };
})(Drupal, jQuery,once);
